import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { CookieService } from 'src/app/services/cookie.service';
import { AccessibilityService } from 'src/app/services/accessibility.service';
import { Language, LanguageService } from 'src/app/services/language-service.service';
import { PointsAndLivesService } from 'src/app/services/points-and-lives.service';
import { Difficulty, QuestionService } from 'src/app/services/question.service';
import { TimerService } from 'src/app/services/timer.service';

@Component({
  selector: 'app-end-game',
  templateUrl: './end-game.component.html',
  styleUrls: ['./end-game.component.css']
})
export class EndGameComponent implements OnInit, OnDestroy {

  public endScore = 0;
  public highestStreak = 0;
  public correctAnswers = 0;
  public difficulty: Difficulty = Difficulty.Easy;

  public skillLevelText = 'skill_level_';
  public skillLevelDescription = 'skill_level_description_';
  public skillLevel = 0;

  public visualAccessibilityOn = false;
  public colorblindModeOn = false;
  public keyboardControlOn = false;

  public uiLanguage = Language.FIN;

  private keyboardSubscriber: Subscription;

  constructor(private accessibilityHandler: AccessibilityService,
              private cookieService: CookieService,
              private languageService: LanguageService,
              private questionService: QuestionService,
              private timerService: TimerService,
              private pointsAndLivesService: PointsAndLivesService,
              private router: Router) { }

  ngOnInit(): void {
    this.pointsAndLivesService.CheckRelevantCookieData();
    this.accessibilityHandler.CheckRelevantCookieData();
    this.languageService.CheckRelevantCookieData();

    this.uiLanguage = this.languageService.uiLanguage;

    this.visualAccessibilityOn = this.accessibilityHandler.highContrastAccessibilityOn;
    this.colorblindModeOn = this.accessibilityHandler.colorBlindAccessibilityOn;

    this.endScore = this.pointsAndLivesService.currentPoints;
    this.highestStreak = this.pointsAndLivesService.highestStreak;
    this.correctAnswers = this.pointsAndLivesService.correctAnswers;
    this.difficulty = this.languageService.learnDifficulty;

    if (this.correctAnswers >= 20) {
      this.skillLevel += 5;
    }
    else if (this.correctAnswers >= 15) {
      this.skillLevel += 4;
    }
    else if (this.correctAnswers >= 11) {
      this.skillLevel += 3;
    }
    else if (this.correctAnswers >= 7) {
      this.skillLevel += 2;
    }
    else {
      this.skillLevel += 1;
    }

    this.keyboardControlOn = this.accessibilityHandler.keyboardAccessibilityOn;

    this.keyboardSubscriber = this.accessibilityHandler.keyEventObs.subscribe(buttonPress => {

      if (buttonPress.key === 't') {
        this.keyboardControlOn = true;
      }

      if (!this.accessibilityHandler.keyboardAccessibilityOn) {
        return;
      }

      if (buttonPress.key === 'Enter') {
        this.router.navigate(['/']);
      }

      if (buttonPress.key === ' ') {
        this.InitReplay();
      }

    });

    this.pointsAndLivesService.SetEndScoreShown();
  }

  ngOnDestroy(): void {
    this.keyboardSubscriber.unsubscribe();
  }

  public InitReplay(): void {
    this.cookieService.RemoveAllCookies();
    this.languageService.SaveCurrentValues();
    this.questionService.SetNewGameValues();
    this.timerService.SetNewGameValues();
    this.pointsAndLivesService.SetNewGameValues();
    this.accessibilityHandler.SaveCurrentValues();
    this.router.navigate(['/game']);
  }

}
